import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ThemeService } from '../../../core/theme/theme.service';
import { IconComponent } from '../icon/icon.component';

/** Sun/moon switch wired to ThemeService. */
@Component({
  selector: 'app-theme-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    <button
      class="toggle focus-ring"
      type="button"
      (click)="theme.toggle()"
      [attr.aria-label]="
        theme.isDark()
          ? labelLight
          : labelDark
      "
      [title]="theme.isDark() ? labelLight : labelDark"
    >
      <app-icon [name]="theme.isDark() ? 'light_mode' : 'dark_mode'" [size]="20" />
    </button>
  `,
  styles: [
    `
      .toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border-radius: var(--radius-md);
        color: var(--on-brand);
        background: rgba(255, 255, 255, 0.16);
        border: 1px solid rgba(255, 255, 255, 0.25);
        cursor: pointer;
        transition: background var(--dur-normal) var(--ease-out);
      }
      .toggle:hover {
        background: rgba(255, 255, 255, 0.28);
      }
    `,
  ],
})
export class ThemeToggleComponent {
  protected readonly theme = inject(ThemeService);
  protected readonly labelDark = $localize`:@@theme.dark:Switch to dark mode`;
  protected readonly labelLight = $localize`:@@theme.light:Switch to light mode`;
}
